<template>
  <v-card :elevation="$root.ele" flat class="mt-4">
    <v-card-text>
      <div class="d-flex align-sm-center flex-column flex-sm-row">
        <v-text-field
          outlined
          hide-details
          dense
          style="flex:1"
          label="Search by name"
          v-model="search"
          clearable
        />
        <div
          class="d-flex align-center justify-end"
          :class="$root.isMobile ? 'pt-3' : ''"
        >
          <v-btn
            color="grey"
            height="40"
            class="ml-2"
            @click="reset()"
            outlined
            tile
            depressed
            width="100"
            >Reset</v-btn
          >
          <v-btn
            @click="$emit('input', search)"
            class="primary ml-2"
            width="100"
            height="40"
            depressed
            tile
          >
            Search
          </v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      search: ""
    };
  },
  methods: {
    reset() {
      const vm = this;
      vm.search = "";
      vm.$emit("input", "");
    }
  }
};
</script>

<style></style>
